//repreater block
const ProcessContent = ({processContent})  => {
    return(
        <>
        <div className="process-panels-container">
            <div className="divider"></div>
            {Array.isArray(processContent) && processContent.slice(0, 3).map((processContentItem) => (
            <div className="process-panel" key={processContentItem._key}>
                <div className="process-phase">
                    <p style={{ backgroundColor: processContentItem.accordionGroup_color ? processContentItem.accordionGroup_color.hex : '#fff'}}>{processContentItem.accordionGroup_subTitle}</p>
                </div>
                <h2 className="process-name">{processContentItem.accordionGroup_title} </h2>
                <p className="process-desc">{processContentItem.accordionGroup_content}</p>
            </div>
            ))}
        </div>
        </>
    );
}

export default ProcessContent;